export default __webpack_public_path__ + "images/lu-adc8f77e99b53bd83b54e64df9ee9ceb.svg";